<!-- 课堂测试 -->
<template>
    <div class="fuzzy-matching-box" >
     <div class="roomCeshi" v-if="titleValue == '课堂测试'" >
      <div class="fuzzy-matching-top" >
        <el-row class="top-first-line the-second-line">
          <el-col :span="5">
            <el-form-item label="班级：">
              <el-input v-model="Dform.className" placeholder=''></el-input>
            </el-form-item>
          </el-col >
          <el-col :span="5">
            <el-form-item label="测试名称：">
              <el-input v-model="Dform.username" placeholder=''></el-input>
            </el-form-item>
          </el-col >
            <el-col :span="5">
            </el-col >
            
          <el-button type="primary" class="query-button" @click="entrylogClick">查询</el-button>
          <el-button type="primary" class="ceshi-button" @click="FabuClick" >发布测试</el-button>
        </el-row>
      </div>
      <div class="fuzzy-matching-bottom">
        <el-row class="list">
           <el-table
                stripe
                :border="true"
                v-loading="loading"
                :header-cell-style="{background:'#EDF6FF',color:'#000',}"
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                @selection-change="handleSelectionChange">
            <el-table-column
              prop="examName"
              label="名称"
              >
            </el-table-column>
            <el-table-column
              prop="gradeName"
              label="年级"
              >
            </el-table-column>
            <el-table-column
            prop="className"
            label='班级'
            >
            </el-table-column>
            <el-table-column
              prop="createTime"
              label="发布时间"
              >
            </el-table-column>
            <el-table-column
              label="状态"
              >
              <template #default="scope">
              <span v-if="scope.row.status == 0">{{'未开启'}}</span>
              <span v-if="scope.row.status == 1">{{'开启中'}}</span>
              <span v-if="scope.row.status == 2">{{'已结束'}}</span>

            </template>
            </el-table-column>
            <el-table-column
              label="录入答案"
              >
              <template #default="scope">
              <el-button type="text"  class="textButton" size="small" @click="luru(scope.row)">录入</el-button>
            </template>
            </el-table-column>
            <el-table-column
              label="测试结果"
              >
              <template #default="scope">
              <el-button type="text" size="small"  class="textButton" @click="lookClick(scope.row)">查看</el-button>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              >
              <template #default="scope">
                <el-button type="text" size="small" class="textButton" @click="startClick(scope.row)" v-if="scope.row.status === 1">结束考试</el-button>
                    <el-button type="text" size="small" class="textButton" @click="HintBtn(scope.row)" v-else>开始考试</el-button>
                    <el-button type="text" size="small" class="shanchuBtn" @click="deleteClick(scope.row)">删除</el-button>
                </template>
            </el-table-column>
          </el-table>
  
          <div class="block-fenye" >
            <el-pagination
                :small="small"
                :disabled="disabled"
                :background="background"
                layout="prev, pager, next, jumper"
                :total="total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
              />
          </div>
        </el-row>
  
      </div>
     </div>
      <DeviceAdd v-if="FabuAddShow" @FabuShow="FabuShow"  ></DeviceAdd>
      <Look v-if="titleValue == '查看结果'"  @roomClickShow="roomClickShow" :lookObj="lookObj" ></Look>
      <entering v-if="titleValue == '录入'" :examBaseInfoObj="examBaseInfoObj" @luruFanhui="luruFanhui" ></entering>
    </div>
  </template>
  
  <script>
  import { classroomAnswerList,classroomDelete ,classroomAnswerStatus,examBaseInfo} from '@/assets/api/renyuan'
  import { ElMessage } from 'element-plus'
  import DeviceAdd from './roomadd/fabuAdd.vue'
  import Look from './lookadd/look.vue'
  import entering from './entering/index.vue'
  export default {
    components: {
      DeviceAdd,
      Look,
      entering,
    },
    data() {
        return {
          lookShow:false,
          FabuAddShow:false,
          loading:true,
          Dform: {
            className:'',
            username:'',
          },
          lookObj:{},
          tableData:[{
            loginTime:'1'
          }],
          multipleSelection:[],
          pageInfo: {
              page: 1,
              pageSize: 13,
          },
          total: 0,
          titleValue:'课堂测试',
          examBaseInfoObj: {}
        };
    },
    created() {
      this.classroomAnswerListSeacher()
    },
    mounted() {
  
    },
    methods: {
      luruFanhui () {
        this.titleValue = '课堂测试'
        this.classroomAnswerListSeacher()
      },
      luru (item) {
        console.log(item,'录入');
        examBaseInfo({ id:item.examId }).then((res)=> {
          console.log(res,'录入答案');
          this.examBaseInfoObj = res.data.data
          this.examBaseInfoObj.examId =item.examId
          this.titleValue = '录入'
        }).catch((err)=> {

        })
      },
      // 父传子点击时间
      roomClickShow(){
        this.titleValue = '课堂测试'
        this.classroomAnswerListSeacher()
      },
      //查看
      lookClick(item){
        // console.log(imei,'查看结果');
        this.lookObj = item
        this.titleValue = '查看结果'
      },
      //发布测试
        FabuClick(){
          this.FabuAddShow = true
        },
        // 父传子点击 
        FabuShow(){
          this.FabuAddShow = false
          this.classroomAnswerListSeacher()
        },
        HintBtn(item){
          examBaseInfo({ id:item.examId }).then((res)=> {
                console.log(res.data.data.answer,'录入答案');
                if (res.data.data.answer != null && res.data.data.answer != '') {
                  this.startClick(item)
                }else{
                  this.$message({
                          type: 'error',
                          message: '请先录入答案，在开启考试！'
                      });
                }
           })
        },
        //考试
        startClick(item){
          if (item.status == 2|| item.status == 0)  {
            classroomAnswerStatus(item.examId,1).then((res)=>{
            console.log(res,'考试开启成功');
                this.$message({
                              type: 'success',
                              message: '开启中'
                        });
                      this.classroomAnswerListSeacher()

                }).catch((err) => {
                  console.log(err,'考试开启失败');
                  this.$message({
                          type: 'error',
                          message: err.response.data.msg
                      });

          })
          }else if (item.status == 1) {
            classroomAnswerStatus(item.examId,2).then((res)=>{
                this.$message({
                              type: 'success',
                              message: '结束考试'
                        });
                      this.classroomAnswerListSeacher()

                }).catch((err) => {
                  this.$message({
                          type: 'error',
                          message: err.response.data.msg
                      });

          })
          }
          // let num = 2
          // if (item.status == 1) {
          // classroomAnswerStatus(item.examId,).then((res)=>{
          //   console.log(res,'考试开启成功');
          // this.$message({
          //               type: 'success',
          //               message: '开启中'
          //         });
          //       this.classroomAnswerListSeacher()

          // }).catch((err) => {
          //   console.log(err,'考试开启失败');
          //   this.$message({
          //           type: 'error',
          //           message: err.response.data.msg
          //       });

          // })
          // }else if (item.status == 2) {
          //   classroomAnswerStatus(item.examId,num).then((res)=>{
          //   console.log(res,'考试开启成功');
          //   this.$message({
          //           type: 'success',
          //           message: '结束成功'
          //       });
          //   this.classroomAnswerListSeacher()

          // }).catch((err) => {
          //   console.log(err,'考试开启失败');
          //   this.$message({
          //           type: 'error',
          //           message: err.response.data.msg
          //       });

          // })
          // }
        },
        kaoshiApi(){
        
        },

        //删除
        deleteClick(item){
            const params = {
                examId:item.examId
            }
            classroomDelete(params).then((res) => {
                this.classroomAnswerListSeacher()
                ElMessage.success('删除成功') 
              
            }).catch((err) => {
                ElMessage.error('删除失败') 

            })
        },
        //列表
        classroomAnswerListSeacher(){
          const params = {
                  className:this.Dform.className,
                  page: this.pageInfo.page,
                  pageSize: this.pageInfo.pageSize,
                  testName: this.Dform.username,
                  userId:JSON.parse(localStorage.getItem('user')).id,
  
             }
           classroomAnswerList(params).then((res)=> {
               this.tableData = res.data.data.list
               this.total = res.data.data.total
               console.log(res ,'-----------------课堂答题');
                this.loading = false
              }).catch((err)=> {
                  console.log(err);
              })
        },  
        //查询
        entrylogClick(){
          // this.pageInfo.page = 1
          this.classroomAnswerListSeacher()
        },
          handleSizeChange (val) {
              console.log(`${val} items pr page`)
          },
          handleCurrentChange (val) {
            console.log(val,'11111111111111111111111');
            this.pageInfo.page = val
            this.classroomAnswerListSeacher()
          },
      
    },
  };
  </script>
  <style scoped lang="scss">
    .fuzzy-matching-box {
      padding-top: 20px;
      width: 100%;
      height:  96%;
      background-color: #fff;
      border-radius: 8px;
      .title-top {
          padding: 20px 20px;
      }
      .roomCeshi{
        height: 100%;
      }
      .fuzzy-matching-top {
      height: 60px ;
      background-color: #fff;
      border-radius: 8px;
      .top-first-line {

        :deep() {
          .el-form-item--small .el-form-item__label {
            // background-color: red;
            font-size: 16px;
          }
          .el-form-item--small .el-form-item__label {
            width: 110px;
            text-align: right;
            height: 35px;
            line-height: 35px;          
          }
          .el-input {
            width: 100%;
            height: 35px;
          }
        }
      }
      .the-second-line {
        margin-top: 15px;
        position: relative;
        .query-button {
          position: absolute;
          right: 800px;
          padding: 16px 24px;
          // top: 50%;
          // transform: translate(0,-50%);
          // background-color: #1677FF;
        }
        .ceshi-button {
          position: absolute;
          right: 650px;
          padding: 16px 24px;
          // top: 50%;
          // transform: translate(0,-50%);
          // background-color: #1677FF;
        }
       
      }
      :deep() {
        .el-range-editor--small.el-input__wrapper {
            height: 35px;
            line-height: 35px;  
        }
        
      }
    }
    .fuzzy-matching-bottom {
      height: calc(100% - 170px);
      overflow: auto;
      position: relative;
      padding: 0px 20px;
      padding-top: 10px;
      margin-top: 15px;
      background-color: #fff;
      border-radius: 8px;
      .textButton {    
        margin: 2px;
        padding: 0px;
        font-size: 15px !important;
        font-weight: 700;
      }
      .shanchuBtn {    
        margin: 2px;
        padding: 0px;
        font-size: 15px !important;
        font-weight: 700;
        color: red;
      }
        
      .top-first-line {
        height: 45px;
        line-height: 45px;
          :deep(.tip-button) {
            padding: 14px 14px;
            margin: 0px 3px;
          }
       
      }
      .list {
        position: relative;
        // margin-top: 10px;
        padding-bottom: 50px;
        :deep() {
        
          .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf {
            // border: 0px;
          }
          .el-table th.el-table__cell>.cell{
            font-weight: 700;
            font-size: 15px;
          }
          .el-table tr {
            height: 40px;
            cursor: pointer;
            font-size: 16px;
            user-select: initial;
  
          }
          .el-button--text{
            font-size: 15px !important;
          }
           .el-table__cell{
            text-align: center;
          }
      
        }
         .block-fenye {
          // float: right;
          position: absolute;
          bottom: 0px;
          left: 50%;
          transform: translate(-50%,0);
          
        }
      }
    }
  }
  </style>
  